import { useQuery } from '@tanstack/react-query'
import type { AuthResponse } from '@/tygo/dto'
import { apiFetch } from '@/lib/http'

const REFRESH_INTERVAL_MS = 13 * 60 * 1000 // 13 minutes (2 min buffer before 15 min expiry)

export function useTokenRefresh(enabled: boolean) {
  return useQuery({
    queryKey: ['auth'] as const,
    queryFn: () =>
      apiFetch<AuthResponse>('/api/v1/auth/refresh', { method: 'GET' }),
    refetchInterval: REFRESH_INTERVAL_MS,
    enabled,
  })
}
